import {Injectable} from '@angular/core';
import {RegisterDataTableService} from '../../../core/services/register-data-table.service';
import {StorageService} from '../../../core/services/storage.service';
import {ITableColumn} from '../../../core/common/interfaces/table-column.interface';
import {CurrentUserService} from "../../../core/services/user.service";


@Injectable({
  providedIn: 'root'
})
export class GradeTableService extends RegisterDataTableService {


  constructor(
    storageService: StorageService,
    private currentService: CurrentUserService
  ) {
    super(storageService);
  }


  override getColumns(): ITableColumn[] {
      const isFirm = this.currentService.value.roles.length===1 && this.currentService.value.roles[0].code === 'organization';
     const res =  [
      {
        name: 'id',
        title: 'Id',
        default: true,
        useCustomTemplate: false,
      },
      {
        name: 'createAt',
        title: 'Дата создания',
        default: true,
        useCustomTemplate: true,
      },
      {
        name: 'organizationName',
        title: 'Учреждение',
        default: true,
        useCustomTemplate: true,
      },
      {
        name: 'period',
        title: 'Тип оценки',
        default: true,
        useCustomTemplate: true,
      },
      {
        name: 'year',
        title: 'Год',
        default: true,
        useCustomTemplate: false,
      },
      {
        name: 'quarter',
        title: 'Квартал',
        default: true,
        useCustomTemplate: true,
        option: 'TEST OPTION'
      },
      {
        name: 'executorName',
        title: 'Исполнитель оценки',
        default: true,
        useCustomTemplate: false,
      },
      {
        name: 'user',
        title: 'ФИО Исполнителя',
        default: true,
        useCustomTemplate: true,
      },
      {
        name: 'gradeStatus',
        title: 'Статус',
        default: true,
        useCustomTemplate: true,
      },
      {
        name: 'filledByExecutor',
        title: 'Заполнено Исполнителем',
        default: true,
        useCustomTemplate: true,
      },
      {
        name: 'filledForOrganization',
        title: 'Заполнено по Учреждению',
        default: true,
        useCustomTemplate: true,
      },
      {
        name: 'status',
        title: 'Архив',
        useCustomTemplate: true,
        disabled: false,
        default: false,
      },
      {
        name: 'comment',
        title: 'Комментарий',
        useCustomTemplate: false,
        default: false,
      },
    ];

     if (isFirm) {
         return res.filter((item) => {
           return item.name !== 'filledForOrganization';
         });
     }
      return res;

  }


}
